import { ExportToXlsxWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ExportToXlsx')
export class ExportToXlsxNodeSchemaProvider extends SchemaProvider<ExportToXlsxWorkflowNode> {}
